<div [class]="[classNames(), 'absolute z-10 mob:hidden'] | joinClassNames">
    <div
        class="flex justify-center items-center w-50px h-50px bg-gray border border-solid border-gray-2 box-shadow-1 rounded-full">
        <img
            [ngSrc]="avatarImg() | asset: 'shared/avatar'"
            width="40"
            height="40"
            alt="avatar"
            class="border-gradient" />
    </div>
    <div
        [class]="
            [
                position(),
                'text-dark-6 text-small-medium box-shadow-1 flex items-center relative px-15px py-5px gap-1 w-max bg-white content-block left-[40px]',
            ] | joinClassNames
        ">
        {{ title() }} <span class="text-dark-2">{{ subtitle() }} {{ smile() }}</span>
    </div>
</div>
